import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { User } from '../_models/user';
import { protectedResources } from '../auth-config';

@Injectable({
  providedIn: 'root'
})
export class GraphService {

  user: User = {
    displayName: "",
    groupIDs: [],
  };
  
  uri = protectedResources.graphApiGroups.endpoint;

  constructor(private http: HttpClient) { }

  getGroups() {
    return this.http.get(this.uri);
  }

  getNextPage(nextPage: any) {
    return this.http.get(nextPage);
  }
}
